"use client";

import { init as initApm } from "@elastic/apm-rum";
import packageJson from "../package.json";

type Props = {
  environment: string | undefined;
};

export const Apm = (props: Props) => {
  const { environment = "development" } = props;

  initApm({
    serviceName: packageJson.name,
    serverUrl: "https://apm.onemindservices.com",
    serviceVersion: packageJson.version,
    breakdownMetrics: true,
    environment: environment,
  });
  return <></>;
};
